<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="consentement1" v-model="sasConsentement.consentement1" :live="liveSasConsentement(5902)" />
    <CatalogueLive code="consentement3" v-model="sasConsentement.consentement3" :live="liveSasConsentement(5904)" />
    <CatalogueLive code="consentement4" v-model="sasConsentement.consentement4" :live="liveSasConsentement(5905)" />
  </v-form>
</template>


<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasConsentement() {
      return this.sas.sasConsentement
    }
  },
  methods: {
    liveSasConsentement(cle) {
      return { endpoint: "sas-consentements", cle: cle, fileId: this.sasConsentement.id }
    }
  }
}
</script>

<style>
</style>